import '../scss/pages/appels_offre.scss';

import "paginationjs/dist/pagination.css";
// R-27 / FINDING-PAGINATIONCONFLICT (2026-07-08) : NE PAS réimporter le paquet npm `paginationjs` ici.
// `global.js` charge déjà le plugin vendored `libs/pagination/pagination.min.js` (paginationjs 2.1.5,
// MÊME version) sur toutes les pages, qui enregistre `$.fn.pagination`. Réimporter le paquet npm faisait
// lever « Pagination: plugin conflicted » au chargement d'appels_offre.js → tout le script (filtres,
// pagination, select2, formulaire d'inscription) restait inerte. On s'appuie sur le plugin global (API
// identique). CSS conservée (mêmes classes `.paginationjs`). Voir NOTE_ARBITRAGE_OPH §14.
import { each, parseHTML } from 'jquery';

const api = require('./modules/api');

(function ($) {
   // - Variables
   const filterBtn = $(".filter-btn");
   const menuFilter = $(".filter-mobile.side-select");
   let filterData = {};
   const _tous = 'Tous';

   /**
    * Init Select2
    */
   setTimeout(() => {
      var dropdownSelect2 = $(".select-select2");

      dropdownSelect2.select2();
      dropdownSelect2.on("select2:open", function (e) {
         if ($(this).next(".select2-container--focus")) {
            $(this).parent().addClass("select-filled");
         }
      });
      dropdownSelect2.on("select2:select", function (e) {
         $(this).parent().addClass("select-filled");
         e.stopPropagation();

         let typeVal = $('.appels-select.type-contrat .select2-selection__rendered').text();
         let lieuVal = $('.appels-select.lieu .select2-selection__rendered').text();
         let keywVal = '';
         if ($('.appels-select.keyword').length > 0){
            keywVal = $('.appels-select.keyword .select2-selection__rendered').text();
         }
         if (typeVal === _tous) typeVal = '';
         if (lieuVal === _tous) lieuVal = '';
         if (keywVal === _tous) keywVal = '';

         if (typeVal !== '' || lieuVal !== '' || keywVal !== '') {
            filterData = $.map(appelListData.item, function (v, i) {
               let _type = appelListData.item[i].type;
               let _lieu = appelListData.item[i].lieu;
               let _keyword = '';

               _lieu = ',' + _lieu.toString() + ',';

               if (keywVal !== '') {
                  _keyword = appelListData.item[i].tag;
                  _keyword = ',' + _keyword.toString() + ',';
               }

               if ( (_type.toUpperCase() === typeVal.toUpperCase() || typeVal === '') &&
                   (_lieu.toUpperCase().includes(',' + lieuVal.toUpperCase() + ',') || lieuVal === '') &&
                   (_keyword.toUpperCase().includes(',' + keywVal.toUpperCase() + ',') || keywVal === '')
                  ) {
                     return appelListData.item[i];
               }
            });
         }
         else {
            // Display all offers
            filterData = appelListData;
         }

         paginationContainer(filterData);
      });
   }, 0);

   // Toggle filter
   var toggleMenuFilter = function toggleMenuFilter() {
      //Dropdown select
      var dropdownSelectElement = $(".oph-form__dropdown").closest(".oph-form-group");
      var selectItem = dropdownSelectElement.find(".dropdown-select .dropdown-menu__item");
      var dropdownMenu = $(".side-select");
      var closeFilterBtn = $(".icon-close");
      var applierBtn = $(".btn-applier");
      var headerHeight = $(".header").height();
      $(window).scrollTop();
      filterBtn.on("click", function () {
         menuFilter.toggleClass("show");
         menuFilter.css("top", headerHeight + "px");
         dropdownMenu.css("top", headerHeight + "px");
      });

      var closeMenuFilter = function closeMenuFilter() {
         menuFilter.removeClass("show");
      };

      closeFilterBtn.on("click", closeMenuFilter);
      applierBtn.on("click", closeMenuFilter);
      // fonctions for Mobile.
      $(".oph-form__dropdown").toArray().forEach(function (element) {
         $(element).on("click", function () {
            var _this = $(element);
            _this.find(".dropdown-select").toggleClass("show");
         });
      });
      selectItem.on("click", function (e) {
         var $this = $(e.currentTarget);
         $this.parents(".oph-form__dropdown").find(".dropdown-input").val($this.text()).trigger("input");

         let typeVal = $('.dropdown-input.type-contrat')[0].value;
         let lieuVal = $('.dropdown-input.lieu')[0].value;
         let keywVal = '';
         if ($('.dropdown-input.keyword').length > 0){
            keywVal = $('.dropdown-input.keyword')[0].value;
         }

         if (typeVal === _tous) typeVal = '';
         if (lieuVal === _tous) lieuVal = '';
         if (keywVal === _tous) keywVal = '';

         if (typeVal !== '' || lieuVal !== '' || keywVal !== '') {
            filterData = $.map(appelListData.item, function (v, i) {
               let _type = appelListData.item[i].type;
               let _lieu = appelListData.item[i].lieu;
               let _keyword = '';

               _lieu = ',' + _lieu.toString() + ',';

               if (keywVal !== '') {
                  _keyword = appelListData.item[i].tag;
                  _keyword = ',' + _keyword.toString() + ',';
               }
               if ( (_type.toUpperCase() === typeVal.toUpperCase() || typeVal === '') &&
                   (_lieu.toUpperCase().includes(',' + lieuVal.toUpperCase() + ',') || lieuVal === '') &&
                   (_keyword.toUpperCase().includes(',' + keywVal.toUpperCase() + ',') || keywVal === '')
               ) {
                  return appelListData.item[i];
               }
            });
         }
         else {
            filterData = appelListData;
         }
         paginationContainer(filterData);
      });
   };
   toggleMenuFilter();

   $(document).ready(function () {
      $(document).on("click", ".status-tag", function (e) {
         e.stopPropagation();
         let statusValue = $(this).attr("data-status");
         filterData = $.map(appelListData.item, function (v, i) {
            let tagArr = appelListData.item[i].tag;
            if (tagArr.includes(statusValue)) {
               return appelListData.item[i];
            }
         });
         paginationContainer(filterData);

         // $("#pagination-container").pagination("destroy");
      });
   });
   // Pagination
   var paginationContainer = function paginationContainer(data) {
      $("#pagination-container").pagination({
         dataSource: data,
         prevText: "<i class='icon-arrow-left'></i>",
         nextText: "<i class='icon-arrow-right'></i>",
         locator: "item",
         pageSize: 4,

         afterRender: function () {
            $("body,html").animate(
                {
                   scrollTop: 0,
                },
                200
            );
         },
         callback: function (data, pagination) {
            var html = simpleTemplating(data);
            $("#data-container").html(html);
         },
      });
   };
   paginationContainer(appelListData);

   function simpleTemplating(data) {
      let appelTicket = "<div class='appels-list'>";
      if (data.length === 0 ) {
         appelTicket += `Aucune offre en cours`;
      }
      // ===== Display all offers =====0
      $.each(data, function (index, item) {
         let statusTicket = "<div class='d-lg-flex align-items-center py-3'>";
         // ===== Display tag =====
         $.each(data[index].tag, function (item, i) {
            statusTicket +=
               "<a href='javascript:void(0)' class='status-tag' data-status='" +
               i +
               "'><span>" +
               i +
               "</span></a>";
         });
         statusTicket += "</div>";

         let typeData = data[index].type_data;
         let avis = ``;
         let dossier = ``;
         let fichePoste = ``;
         let candidature = ``;
         let date_section = '';
         let title = '';
         let operation = '';

         // ===== Display icons (Règlement, Dossier) =====
         if (typeData === "appel_offre") {
            if (data[index].avis !== "") {
               avis = `<div class="btn-item">
                        <a class="btn-icon" href="${data[index].avis}" download="${data[index].avis}" target="_blank">
                           <i class="icon-chat"></i>
                        </a>
                        <p>Avis</p>
                     </div>`;
            }
            if (data[index].dossier !== "") {
               // dossier = `<div class="btn-item">
               //          <a class="btn-icon" href="${data[index].dossier}" download="${data[index].dossier}" target="_blank">
               //             <i class="icon-download-info"></i>
               //          </a>
               //          <p>Dossier</p>
               //       </div>`;
               dossier = `<div class="btn-item">
                        <button class="btn-icon" data-toggle="modal" data-target="#download_appel_offre-${data[index].AppelOffreId}">
                           <i class="icon-download-info"></i>
                        </button>
                        <p>Dossier</p>
                        </div>`;
            }
            candidature = `<div class="btn-item disabled">
                        <a class="btn-icon" href="#">
                           <i class="icon-download-document"></i>
                        </a>
                        <p class="hide-mobile">Déposer une </p>
                        <p class="mt-lg-0">Candidature</p>
                     </div>`;

            date_section = `<div class="date d-flex align-items-center pl-lg-3">
                <i class="icon-clock"></i>
                <span class="px-1 text--medium">Date limite</span>
            <span class="text--light">${data[index].date}</span>
            <small class="text--light">&nbsp;(${data[index].time})</small>
                </div>`;
         }
         else if (typeData === "job") {
            if (data[index].urlDetail) {
               fichePoste = `<div class="btn-item">
                        <a class="btn-icon" href="${data[index].urlDetail}" target="_blank">
                           <i class="icon-search"></i>
                        </a>
                        <p>Détails du poste</p>
                     </div>`;
            }
            candidature = `<div class="btn-item">
                        <a class="btn-icon" href="${data[index].urlApply}">
                           <i class="icon-download-document"></i>
                        </a>
                        <p class="hide-mobile">Déposer une </p>
                        <p class="mt-lg-0">Candidature</p>
                     </div>`;
         date_section = `<div class="date d-flex align-items-center pl-lg-3">
                <i class="icon-clock"></i>
                <span class="px-1 text--medium">Limite de dépôt</span>
            <span class="text--light">${data[index].dateLimite}</span>
                </div>
                <div class="date d-flex align-items-center pl-lg-3">
                <i class="icon-clock"></i>
                <span class="px-1 text--medium">Début prévisionnel</span>
            <span class="text--light">${data[index].dateDebut}</span>
                </div>`;
         }

         // ===== change urlDetail to urlApply
         if (data[index].urlDetail) {
            title = `<a href="${data[index].urlDetail}">${data[index].title}</a>`;
         }else{
            title = `${data[index].title}`;
         }

         if (data[index].operation){
            operation = `<div class="cl-gray-light-02">${data[index].operation}</div>`;
         }

         appelTicket += `<div class='appels-list__item' data-block='${data[index].id}'>
               <div class="type-tag">
                  <span class="text--fs-15">${data[index].type}</span>
               </div>
               <div class="title text--up-fs-25 text--down-fs-19 my-2 text--medium">
                  <h3 class="text--up-fs-25 text--down-fs-19 cl-brown-dark text--medium">${title}</h3>
                  ${operation}
               </div>
               <div class="item-content d-lg-flex">
                  <div class="item-content__info">
                     <div class="d-lg-flex align-items-center cl-brown-dark text--down-fs-13">
                        <div class="destination d-flex align-items-center">
                           <i class="icon-marker"></i>
                           <span class="px-2 text--medium">Lieu</span>
                           <span class="text--light">${data[index].lieu}</span>
                        </div>
                        ${date_section}
                     </div>
                     ${statusTicket}
                  </div>
                  <div class="item-content__group-btn">                    
                     ${avis}
                     ${dossier}
                     ${fichePoste}
                     ${candidature}
                  </div>
               </div>
            </div>`;

            // ======= Download Dossier after subrscribe =======
            $(`#appel_offre_subscriber-${data[index].AppelOffreId}`).on('submit', function(e){
               e.preventDefault();
               var email = $(`#appel_offre_subscriber_email-${data[index].AppelOffreId}`).val();
               $(`#appel_offre_subscriber_email-${data[index].AppelOffreId}`).val(email);
               api.request({
                  type: "POST",
                  url: `/appels-offre-sub/${data[index].AppelOffreId}`,
                  data: {'email': email},
                  success: function(){
                     $(".loader_div").fadeIn();
                     setTimeout(function() {
                        $('.modal-subsciber button[class=close]').click();
                        $(`#appel_offre_subscriber_email-${data[index].AppelOffreId}`).val("");
                        window.open(data[index].dossier, '_blank');
                        $(".loader_div").hide();
                     }, 2000);
                  }
               })
            })
      });
      appelTicket += "</div>";
      return appelTicket;
   }
})(jQuery);
